import { combineReducers } from 'redux';
import { loginReducer, UserReducer } from './reducers';
const reducers = combineReducers({
  login: loginReducer,
  user: UserReducer,
});
export default reducers;
